<template>
    <div class="conte">

        <div class="contes">
           <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/whens' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>账户列表</el-breadcrumb-item>
            </el-breadcrumb> 
        </div>
            
        <div class="content_user">
            <span class="userlist">
                 账户列表
            </span>
           <div class="search_box">
            <span class="search_name">
                <i style="width:20%;margin:0;padding:0">
                    账户名：
                </i>

                 <el-input
                placeholder="请输入账户名"
                v-model="inputName"
                clearable
                class="inputs"
                >
                </el-input>
                 
              
            </span>

            <span class="search_name">
                <i style="width:20%;margin:0;padding:0">
                    所属类别：
                </i>
                 
                <el-select v-model="value" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </span>
           

           <span>
               <el-button @click="clearData">清空/显示全部</el-button>
            <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
           </span>
           </div>

            <!-- 列表展示栏 -->
        <div class="tables">
            <table style="width:98%;text-align:center"  v-loading="loading">
                <tr height="30px">
                    <th>账户名</th>
                    <th>Token</th>
                    <th>账户所属</th>
                    <th>所属环境</th>
                    <th>账户ID</th>
                    <th>账户类别</th>
                </tr>
                <tr v-for="item in this.userData" :key="item._id">
                    <td>{{item.username}}</td>
                    <td>{{item.secret}}</td>
                    <td>{{item.title}}</td>
                  
                    <td>{{item.env}}</td>
                    <td>{{item._id}}</td>
                    <td>{{item.class}}</td>
                </tr>
            </table>
        </div>


        </div>



    </div>
</template>
<script>

export default {
    name:'system',
    data() {
        return {
              options: [{
                value: '长安典当行',
                label: '长安典当行'
                }, {
                value: '双庆典当行',
                label: '双庆典当行'
                }, {
                value: '双庆典当行(南城店)',
                label: '双庆典当行(南城店)'
                }],
                value: '',

                inputName:'',

                loading:true,

                userData:[]
        }
    },
    methods:{
        //清空数据
        clearData(){
            this.inputName = '',
            this.value = '',
            this.getData()
        },

        //请求所有数据
        getData(){
        this.axios
            .get("/getUser/GetUserDataAll",{
                params:{
                    Id:'20230913'
                }
            }).then(res=>{
               
                if(res.status == 200){
                    this.loading = false
                  this.userData = res.data
                }
          })
        },

        //搜索按钮
        SearchData(){
            //输入框有值才能搜索
            if( this.inputName !=='' || this.value !=='' ){
                this.loading = true
                this.axios
                .get("/getUser/GetUserDataFilter",{
                    params:{
                        username:this.inputName,
                        title:this.value
                    }
                }).then(res=>{
                     this.loading = false
                  this.userData = res.data
                    console.log(res)
                   
                })
            }else{
                  this.$alert('请输入查询信息', '温馨提示', {
                    confirmButtonText: '关闭',
                  
                    });
            }
            
        }

       
    },
    created(){
    //      //获取到this.ACCESS_TOKEN
    //  this.getTokens()

    //  this.getUserToken()

    },
    mounted() {
        //请求所有账户数据
        this.getData()
    },
}
</script>
<style scoped>
.contes{
    width: 100%;
    height: 40px;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    /* justify-content: center; */
    align-items: center;
   
}
.content_user{
    margin-top:15px;
    width: 100%;
    /* height: 100%; */
    background-color: #ffffff;
}
.userlist{
    /* margin: 30px 20px; */
    padding: 30px 20px;
    font-size: 20px;
}
.search_name{
    display: flex;
    flex-direction:row;
    align-items: center;
    margin: 15px;
    width: 20%; 
}
.search_name span{
    width: 100%;
}
.search_name input{}
/* .inputs{
    width: 100%;
} */
.search_box{
    display: flex;
    flex-direction: row;
    align-items: center;
}

table
{
    border-collapse:collapse;
    
}
table,th, td
{
    border: 1px solid black;
    
}


.tables table{
    margin: 10px auto;
}
</style>